import React from 'react';
export function Footer() {
  return <footer className="bg-burgundy text-cream py-16 px-4 md:px-8 text-center border-t-4 border-gold" data-id="element-98">
      <div className="max-w-4xl mx-auto" data-id="element-99">
        <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-100">🌟 CÓDIGO HIJO</h2>

        <p className="text-lg md:text-xl font-serif text-dusty-rose mb-2" data-id="element-101">
          El sistema de crianza consciente N°1 para mamás latinas.
        </p>
        <p className="text-base md:text-lg text-cream/80 italic mb-12" data-id="element-102">
          Porque criar a tu hijo no debería costarte tu paz.
        </p>

        <div className="pt-8 border-t border-white/10 text-xs md:text-sm text-cream/50 space-y-2" data-id="element-103">
          <p data-id="element-104">© Código Hijo 2025 — Valentina Ríos</p>
          <p data-id="element-105">Todos los derechos reservados.</p>
          <p data-id="element-106">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}